/** @jsx h */
import { h } from 'preact'
import { ErrorBoundary } from '@appsignal/preact'

const ErrorTracker = props => {
  const appsignal = window.provenance.appsignal
  if (appsignal) {
    return (
      <ErrorBoundary
        instance={appsignal}
        tags={{ tag: 'client' }}
      >
        {props.children}
      </ErrorBoundary>
    )
  } else {
    return props.children
  }
}

export default ErrorTracker
